import { AbstractControl } from "@angular/forms";

// helper interface
interface ValidationResult {
  [key: string]: boolean;
}

export class GlobalValidator {
  static emailFormat(control: AbstractControl): ValidationResult | any {
    if (control.value) {
      const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
      if (control.value !== "" && (control.value.length <= 5 || !EMAIL_REGEXP.test(control.value))) {
        return { emailFormat: true };
      }
    } else {
      return null;
    }
  }
}
